import React from "react";
import PropTypes from "prop-types";
import TextStory from "../text-story";

const VideoAsTextStory = ({ story, config, hasAccess }) => {
  return <TextStory story={story} config={config} hasAccess={hasAccess} />;
};

VideoAsTextStory.propTypes = {
  story: PropTypes.object.isRequired,
  config: PropTypes.object,
  hasAccess: PropTypes.bool,
};

export default VideoAsTextStory;
